export class RuleInvariantError extends Error {
    constructor(message) {
        super(message);
        this.name = 'RuleInvariantError';
    }
}
//# sourceMappingURL=rule-invariant-error.js.map